export default
{
    "iconsApp": [
      {
        "ui_app_icon_id": 1,
        "ui_app_icon_name": "ic_perm_identity_24px",
        "ui_app_icon_mnem": "avatar",
        "is_Global": 1,
        "application_id": null,
        "ui_app_icon_file_name": "ic_perm_identity_24px",
        "ui_app_icon_file": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z\"/></svg>"
      },
      {
        "ui_app_icon_id": 2,
        "ui_app_icon_name": "ic_apps_24px",
        "ui_app_icon_mnem": "apps",
        "is_Global": 1,
        "application_id": null,
        "ui_app_icon_file_name": "ic_apps_24px",
        "ui_app_icon_file": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z\"/></svg>"
      },
      {
        "ui_app_icon_id": 10,
        "ui_app_icon_name": "ic_add_alert_24px",
        "ui_app_icon_mnem": "tabl",
        "is_Global": 1,
        "application_id": null,
        "ui_app_icon_file_name": "ic_add_alert_24px",
        "ui_app_icon_file": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zm8.87-4.19V11c0-3.25-2.25-5.97-5.29-6.69v-.72C13.59 2.71 12.88 2 12 2s-1.59.71-1.59 1.59v.72C7.37 5.03 5.12 7.75 5.12 11v5.82L3 18.94V20h18v-1.06l-2.12-2.12zM16 13.01h-3v3h-2v-3H8V11h3V8h2v3h3v2.01z\"/></svg>"
      },
      {
        "ui_app_icon_id": 11,
        "ui_app_icon_name": "table",
        "ui_app_icon_mnem": "imgtable",
        "is_Global": 1,
        "application_id": null,
        "ui_app_icon_file_name": "table",
        "ui_app_icon_file": "/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAIBAQIBAQICAgICAgICAwUDAwMDAwYEBAMFBwYHBwcGBwcICQsJCAgKCAcHCg0KCgsMDAwMBwkODw0MDgsMDAz/2wBDAQICAgMDAwYDAwYMCAcIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCAAuAC0DASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD4o+BH7GfxU/ae0m/v/h94D8R+LrPS5lt7ubTbUzLbyMNwViOhI5rvP+HSn7S3/RFfH3/gtavrj/ggZ8EPj18VvhF4/uPhD8brH4Vadaaxbx6haT+FLPWTfSmElZA86kpheMDg9a++/wDhjr9tj/o8TRv/AA2Wlf8AxFdEp2djnULo/Ez/AIdKftLf9EV8ff8Agtaj/h0p+0t/0RXx9/4LWr9s/wDhjr9tj/o8TRv/AA2Wlf8AxFH/AAx1+2x/0eJo3/hstK/+IqfaFch+Jn/DpT9pb/oivj7/AMFrV87V/R5/wx1+2x/0eJo3/hstK/8AiK/nDq4yuRKNj7Z/4JX3f7Glv4A8VD9p21nn106hF/YhjOsjFt5fz/8AHgwX7/8Af59OK+qP7U/4JLf9A68/768W/wDxdeY/8EIvjP8AtGfC/wCE3jyD4J/BzQ/ibpd1q8EmpXV/4gttMaymEJCxqss0ZYFecgGvvD/hrj9vn/o07wb/AOFzp/8A8l1Mt/8Aglx2/wCAfLv9qf8ABJb/AKB15/314t/+Lo/tT/gkt/0Drz/vrxb/APF19Rf8Ncft8/8ARp3g3/wudP8A/kuj/hrj9vn/AKNO8G/+Fzp//wAl1P8AW4/62Pl3+1P+CS3/AEDrz/vrxb/8XX4/V/RH/wANcft8/wDRp3g3/wALnT//AJLr+dyrgRM+/P8Agjz8PNI8afDbxjLqX7XF9+zg8OpwqmmweJYNKGsAxZ88rJcRF9v3cgHHrX2H/wAKI8Lf9JSNY/8ADg2f/wAn1+IFFNxu7iUrH7f/APCiPC3/AElI1j/w4Nn/APJ9H/CiPC3/AElI1j/w4Nn/APJ9fiBRS5B83kft/wD8KI8Lf9JSNY/8ODZ//J9fiBRRVJWJbuf/2Q=="
      },
      {
        "ui_app_icon_id": 2,
        "ui_app_icon_name": "ic_apps_24px",
        "ui_app_icon_mnem": "apps",
        "is_Global": 1,
        "application_id": null,
        "ui_app_icon_file_name": "ic_apps_24px",
        "ui_app_icon_file": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z\"/></svg>"
      },
      {
        "ui_app_icon_id": 22,
        "ui_app_icon_name": "ic_refresh_24px",
        "ui_app_icon_mnem": "fulltable",
        "is_Global": 1,
        "application_id": null,
        "ui_app_icon_file_name": "ic_refresh_24px",
        "ui_app_icon_file": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M15,3l2.3,2.3l-2.89,2.87l1.42,1.42L18.7,6.7L21,9V3H15z M3,9l2.3-2.3l2.87,2.89l1.42-1.42L6.7,5.3L9,3H3V9z M9,21 l-2.3-2.3l2.89-2.87l-1.42-1.42L5.3,17.3L3,15v6H9z M21,15l-2.3,2.3l-2.87-2.89l-1.42,1.42l2.89,2.87L15,21h6V15z\"/></svg>"
    },
    {
      "ui_app_icon_id": 23,
      "ui_app_icon_name": "ic_refresh_24px",
      "ui_app_icon_mnem": "fulltableexit",
      "is_Global": 1,
      "application_id": null,
      "ui_app_icon_file_name": "ic_refresh_24px",
      "ui_app_icon_file": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M9,9l0-6L7,3l0,2.59L3.91,2.5L2.5,3.91L5.59,7L3,7l0,2L9,9z M21,9V7l-2.59,0l3.09-3.09L20.09,2.5L17,5.59V3l-2,0l0,6L21,9z M3,15l0,2h2.59L2.5,20.09l1.41,1.41L7,18.41L7,21h2l0-6L3,15z M15,15l0,6h2v-2.59l3.09,3.09l1.41-1.41L18.41,17H21v-2L15,15z\"/></svg>"
    },
      {
        "ui_app_icon_id": 13,
        "ui_app_icon_name": "ic_add_circle_24px",
        "ui_app_icon_mnem": "nofilt",
        "is_Global": 1,
        "application_id": null,
        "ui_app_icon_file_name": "ic_add_circle_24px",
        "ui_app_icon_file": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M19.79,5.61C20.3,4.95,19.83,4,19,4H6.83l7.97,7.97L19.79,5.61zM2.81,2.81L1.39,4.22L10,13v6c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v-2.17l5.78,5.78l1.41-1.41L2.81,2.81z\"/></svg>"
      },
      {
        "ui_app_icon_id": 14,
        "ui_app_icon_name": "ic_content_copy_24px",
        "ui_app_icon_mnem": "hide_tables",
        "is_Global": 1,
        "application_id": null,
        "ui_app_icon_file_name": "ic_content_copy_24px",
        "ui_app_icon_file": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M19.3,16.9c0.4-0.7,0.7-1.5,0.7-2.4c0-2.5-2-4.5-4.5-4.5S11,12,11,14.5s2,4.5,4.5,4.5c0.9,0,1.7-0.3,2.4-0.7l3.2,3.2 l1.4-1.4L19.3,16.9z M15.5,17c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S16.9,17,15.5,17z M12,20v2 C6.48,22,2,17.52,2,12C2,6.48,6.48,2,12,2c4.84,0,8.87,3.44,9.8,8h-2.07c-0.64-2.46-2.4-4.47-4.73-5.41V5c0,1.1-0.9,2-2,2h-2v2 c0,0.55-0.45,1-1,1H8v2h2v3H9l-4.79-4.79C4.08,10.79,4,11.38,4,12C4,16.41,7.59,20,12,20z\"/></svg>"
      },
      {
        "ui_app_icon_id": 15,
        "ui_app_icon_name": "ic_edit_24px",
        "ui_app_icon_mnem": "curmarker",
        "is_Global": 1,
        "application_id": null,
        "ui_app_icon_file_name": "ic_edit_24px",
        "ui_app_icon_file": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z\"/></svg>"
      },
      {
        "ui_app_icon_id": 16,
        "ui_app_icon_name": "ic_print_24px",
        "ui_app_icon_mnem": "allmarkers",
        "is_Global": 1,
        "application_id": null,
        "ui_app_icon_file_name": "ic_print_24px",
        "ui_app_icon_file": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z\"/></svg>"
      },
      {
        "ui_app_icon_id": 17,
        "ui_app_icon_name": "ic_delete_24px",
        "ui_app_icon_mnem": "delete",
        "is_Global": 1,
        "application_id": null,
        "ui_app_icon_file_name": "ic_delete_24px",
        "ui_app_icon_file": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z\"/></svg>"
      },
      {
        "ui_app_icon_id": 18,
        "ui_app_icon_name": "ic_search_24px",
        "ui_app_icon_mnem": "search",
        "is_Global": 1,
        "application_id": null,
        "ui_app_icon_file_name": "ic_search_24px",
        "ui_app_icon_file": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z\"/></svg>"
      },
      {
        "ui_app_icon_id": 19,
        "ui_app_icon_name": "ic_save_24px",
        "ui_app_icon_mnem": "save",
        "is_Global": 1,
        "application_id": null,
        "ui_app_icon_file_name": "ic_save_24px",
        "ui_app_icon_file": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z\"/></svg>"
      },
      {
      "ui_app_icon_id": 21,
      "ui_app_icon_name": "ic_filter_alt_off_black_24dp",
      "ui_app_icon_mnem": "filteroff",
      "is_Global": 1,
      "application_id": null,
      "ui_app_icon_file_name": "ic_filter_alt_off_black_24dp",
      "ui_app_icon_file": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M4.25,5.61C6.27,8.2,10,13,10,13v6c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v-6c0,0,3.72-4.8,5.74-7.39 C20.25,4.95,19.78,4,18.95,4H5.04C4.21,4,3.74,4.95,4.25,5.61z\"/></svg>"
      },
      {
        "ui_app_icon_id": 20,
        "ui_app_icon_name": "ic_filter_alt_black_24dp",
        "ui_app_icon_mnem": "filter",
        "is_Global": 1,
        "application_id": null,
        "ui_app_icon_file_name": "ic_filter_alt_black_24dp",
        "ui_app_icon_file": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M4.25,5.61C6.27,8.2,10,13,10,13v6c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v-6c0,0,3.72-4.8,5.74-7.39 C20.25,4.95,19.78,4,18.95,4H5.04C4.21,4,3.74,4.95,4.25,5.61z\"/></svg>"
    },
    {
      "ui_app_icon_id": 25,
      "ui_app_icon_name": "ic_report_24px",
      "ui_app_icon_mnem": "report",
      "is_Global": 1,
      "application_id": null,
      "ui_app_icon_file_name": "ic_report_24px",
      "ui_app_icon_file": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z\"/></svg>"
    },
     
    ],
    "theme": "",
    "blocks": [
      {
        "block_id": 1,
        "block_parent_id": null,
        "block": "header",
        "css": `.AppHeader{\n
          background-color:#abbd0b;\ncolor:#000000;\n
          height:5vh;\n
          margin:27px;\n
          box-shadow:10px 4px 5px -1px rgba(105,104,105,0.53);
          \n}
          .TableImgButton{\nbackground-color:#9ff08d;\n}
          .App-header{\n
            float: left;
            width: 100%;
            position: relative;
            background-color:#343433;\n}\n
            .caption-cell{
              height: 48px;
              font-size: 20px;
              font-style: bold;
              color: rgba(255, 255, 255, 1);
              float: left;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 0px 12px 0px 12px;
            }            
            .user-info{
              height: 48px;
              font: 14px Arial;
              color: rgba(255, 255, 255, 1);
              float: right;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 0px 12px 0px 12px;
            }
            .user-button {
              font-family: 'Material Icons';
              font-weight: normal;
              font-style: normal;
              color: rgb(255, 255, 255);
              font-size: 24px;
              line-height: 1;
              text-transform: none;
              letter-spacing: normal;
              word-wrap: normal;
              white-space: nowrap;
              direction: ltr;
              border-style: none;
              background: none;
              border-radius: 50%;
              -webkit-font-smoothing: antialiased;
              text-rendering: optimizeLegibility;
              -moz-osx-font-smoothing: grayscale;
              font-feature-settings: 'liga';
            }
            `,
        "icons": [
          
        ],
        "children": [
          {
            "block_id": 3,
            "block_parent_id": 1,
            "block": "header-1",
            "css": ".AppHeader-1{\nbackground-color:#0fd430;\ncolor:#0a0a0a;\nheight:4vh;\nborder:1px solid black;\n}.App-header-1{\nwidth:30%;\nheight:2vh;\n}\n",
            "icons": [
              {
                "id": 2,
                "order": null,
                "title": "Пользователь",
                "style": ""
              }
            ],
            "children": [
              
            ]
          },
          {
            "block_id": 11,
            "block_parent_id": 1,
            "block": "header-2",
            "css": ".App-header-2{\nwidth:60%;\n}\n",
            "icons": [
              
            ],
            "children": [
              
            ]
          },
          {
            "block_id": 12,
            "block_parent_id": 1,
            "block": "header-3",
            "css": ".App-header-3{\nwidth:10%;\n}\n",
            "icons": [
              {
                "id": 1,
                "order": null,
                "title": "Аватар",
                "style": ""
              }
            ],
            "children": [
              
            ]
          }
        ]
      },
      {
        "block_id": 2,
        "block_parent_id": null,
        "block": "footer",
          "css": `.App-footer{
            padding: 10px;
            display: flex;
            width: 100%;
            background-color: #343433;
            color: #fff;
            border-bottom: 3px solid #6e767d;
            box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
            height: 7vh;
            font-size: 16
        }\n`,
        "icons": [
          
        ],
        "children": [
          
        ]
      },
      {
        "block_id": 7,
        "block_parent_id": null,
        "block": "maincontent",
        "css": ".App-main{\nwidth:100%;\n}\n",
        "icons": [
          
        ],
        "children": [
          
        ]
      },
      {
        "block_id": 10,
        "block_parent_id": null,
        "block": "toolsbar",
        "css": `.App-toolsbar{
          float: left;
          width: 100%;
          border-bottom-style: solid;
          border-bottom-width: 1px;
          border-bottom-color: rgb(210, 210, 210);
          background-color: rgb(247, 247, 247);
          position:relative;
        }.App-toolsbar-icons-style{\nmargin-left:20px;\nfloat:left;\nfont-size:24px;\ncolor:#6e767d;\n}\n
        .div-button-menu {
          width: 48px;
          height: 48px;
          background: none;
          float: left;
          display: flex;
          align-items: center;
          justify-content: center;
        }\n
        .material-button-menu {
          font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    color: rgba(102, 103, 103, 1);
    font-size: 24px;
    display: inline-block;
    line-height: 1;
    text-transform: none;
    letter-spacing: normal;
    word-wrap: normal;
    white-space: nowrap;
    direction: ltr;
    border-style: none;
    background: none;
    border-radius: 50%;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings: 'liga';
        }\n
        .server-cell {
          height: 48px;
          float: right;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0px 12px 0px 12px;
      }
      .filter-cell {
        height: 100%;
        float: right;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding: 0px 12px 0px 12px;
      }
      .server-div {
        position: relative;
        margin: 0 auto;
        background: rgb(243, 119, 125);
        border-style: solid;
        border-color: rgba(210, 210, 210, 1);
        border-width: 1px;
        border-radius: 14px;
        padding: 0px 12px 0px 12px;
        height: 28px;
        font: 14px Arial;
        color: rgba(102, 103, 103, 1);
        float: left;
        display: flex;
        align-items: center;
        justify-content: center;}
        `,
        "icons": [
          
        ],
        "children": [
          {
            "block_id": 13,
            "block_parent_id": 10,
            "block": "toolsbar-1",
            "css": "\n}\n",
            "icons": [
              {
                "id": 22,
                "order": 9,
                "title": "Карта на весь экран",
                "style": "{ marginLeft:20px; float:left; fontSize:24px; color:#6e767d;}"
              },
              {
                "id": 23,
                "order": 9,
                "title": "Таблица на пол экрана",
                "style": "{ marginLeft:20px; float:left; fontSize:24px; color:#6e767d;}"
              },
              {
                "id": 13,
                "order": 2,
                "title": "Очистить фильтр",
                "style": "{ marginLeft:20px; float:left; fontSize:24px; color:#6e767d;}"
              },
              {
                "id": 14,
                "order": 11,
                "title": "Таблица на весь экран",
                "style": "{ marginLeft:20px; float:left; fontSize:24px; color:#6e767d;}"
              },
              {
                "id": 15,
                "order": 12,
                "title": "Текущая станция",
                "style": "{ marginLeft:20px; float:left; fontSize:24px; color:#6e767d;}"
              },
              {
                "id": 20,
                "order": 1,
                "title": "Фильтр",
                "style": "{ marginLeft:20px; float:left; fontSize:24px; color:red;}"
              },
              {
                "id": 21,
                "order": 1,
                "title": "Фильтр не выбран",
                "style": "{ marginLeft:20px; float:left; fontSize:24px; color:#6e767d;}"
              },
             
              {
                "id": 19,
                "order": 1,
                "title": "Сохранить",
                "style": "{ marginLeft:20px; float:left; fontSize:24px; color:#6e767d;}"
              },
              {
                "id": 16,
                "order": 13,
                "title": "Все станции",
                "style": "{ marginLeft:20px; float:left; fontSize:24px; color:#6e767d;}"
              },
              {
                "id": 17,
                "order": 5,
                "title": "Удалить",
                "style": "{ marginLeft:20px; float:left; fontSize:24px; color:#6e767d;}"
              },
              {
                "id": 25,
                "order": 15,
                "title": "Формирование сводной таблицы",
                "style": "{ marginLeft:20px; float:left; fontSize:24px; color:#6e767d;}",
                /*"download": true*/
              }
            ],
            "children": [
              
            ]
          },
          {
            "block_id": 14,
            "block_parent_id": 10,
            "block": "toolsbar-2",
            "css": "\n}\n",
            "icons": [
              {
                "id": 18,
                "order": null,
                "title": "Поиск",
                "style": ""
              }
            ],
            "children": [
              
            ]
          }
        ]
      }
    ]
  }